module.exports = __webpack_public_path__ + "img/arn-logo.aecd0fb0.svg";